<template>
  <FormInput v-model="modelValue" :name :placeholder="$t('LoginOrReg.confirmPasswordTips')" autocomplete="off" autocapitalize="off"
    :rules="[
      {
        validator: validateConfirmPassword,
        message: $t('LoginOrReg.confirmPasswordErrorTips'),
        trigger: 'onChange'
      },
    ]"
    :type="isPreview ? 'text' : 'password'"
    v-bind="iconProps"
  />
</template>

<script setup lang="ts">
  import FormInput from '@a/components/FormInput'
  import iconShow from '@a/assets/images/i_yulan.png'
  import iconHide from '@a/assets/images/i_view.png'
  const props = withDefaults(
    defineProps<{
      // placeholder?: string
      // errorMsg?: string
      password?: string
      name?: string
      iconPosition?: string
    }>(), {
      // placeholder: 'Confirme a senha inserida',
      // errorMsg: 'As senhas são diferentes.',
      name: 'confirmPassword',
      iconPosition: 'left',
      password: '',
  })

  const isPreview = ref(false)
  const modelValue = defineModel<string>()
  // const validateConfirmPassword = (value: string) => value === props.password
  const validateConfirmPassword = (value: string) => {
    return value === props.password
  }

  const icon = computed(() => isPreview.value ? iconHide : iconShow)
  const iconProps = computed(() => props.iconPosition === 'left' ? {
    leftIcon: icon.value,
    onClickLeftIcon: () => (isPreview.value = !isPreview.value)
  } : {
    rightIcon: icon.value,
    onClickRightIcon: () => (isPreview.value = !isPreview.value)
  })
</script>
